import { render, staticRenderFns } from "./ProductPriceRecap.vue?vue&type=template&id=47682438&"
import script from "./ProductPriceRecap.vue?vue&type=script&lang=js&"
export * from "./ProductPriceRecap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports